import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DesignAngularKitModule } from 'design-angular-kit';
import { RequestService } from '../../../../services/request.service';
import { DischargeInfo, RequestDto } from '../../../../models/request.dto';

@Component({
  selector: 'app-discharge-info',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule],
  templateUrl: './discharge-info.component.html',
  styleUrl: './discharge-info.component.scss',
})
export class DischargeInfoComponent {
  @Input() visibleFields: string[] = [];
  @Input() request!: RequestDto;

  @Input() dischargeInfo: DischargeInfo[] =[];
  loading = true;

  readonly allFields = [
    'presumedDischargeDate',
    'realDischargeDate',
    'facilityRequestDate',
    'facilityConfirmDate',
    'choosedFacility'
  ];

  get fieldsToShow(): string[] {
    return this.visibleFields?.length ? this.visibleFields : this.allFields;
  }

  constructor(private requestService: RequestService) {}

  ngOnInit(): void {
    this.loading = false;
    // if (this.request?.id) {
    //   this.requestService.getDischargeInfo(this.request.id).subscribe((data) => {
    //       this.dischargeInfo = data;
    //       this.loading = false;
    //     },
    //     (error) => {
    //       this.loading = false;
    //     },
    //   );
    // }
  }

  getDateFromType(dateType: string): any {
    return this.dischargeInfo.find(d => d.dateType.code == dateType);
  }
}
